interface Props {
  color?: string;
  className?: string;
  onClick?: () => void;
}

export default function ArrowLeftSvg(props: Props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.22 11.28C8.07931 11.4205 8.00018 11.6112 8 11.81L8 12.19C8.0023 12.3884 8.08112 12.5783 8.22 12.72L13.36 17.85C13.4539 17.9447 13.5817 17.9979 13.715 17.9979C13.8483 17.9979 13.9761 17.9447 14.07 17.85L14.78 17.14C14.8741 17.0479 14.9271 16.9217 14.9271 16.79C14.9271 16.6583 14.8741 16.5322 14.78 16.44L10.33 12L14.78 7.56003C14.8747 7.46614 14.9279 7.33835 14.9279 7.20503C14.9279 7.07171 14.8747 6.94391 14.78 6.85003L14.07 6.15003C13.9761 6.05537 13.8483 6.00213 13.715 6.00213C13.5817 6.00213 13.4539 6.05537 13.36 6.15003L8.22 11.28Z'
        fill={props.color || 'white'}
      />
    </svg>
  );
}
